import { Plus, Trash2 } from "lucide-react";
import { Field, GhostButton, inputClass } from "./fields";

const DEFAULT_GROUPS = ["Dimensions", "Accommodation", "Performance", "Propulsion & Capacities"];

export default function SpecSheetEditor({ value = [], onChange }) {
  const setGroup = (gi, patch) => onChange(value.map((g, j) => (j === gi ? { ...g, ...patch } : g)));
  const setItem = (gi, ii, k, v) => setGroup(gi, { items: value[gi].items.map((it, j) => (j === ii ? { ...it, [k]: v } : it)) });
  const addItem = (gi) => setGroup(gi, { items: [...value[gi].items, { label: "", value: "" }] });
  const removeItem = (gi, ii) => setGroup(gi, { items: value[gi].items.filter((_, j) => j !== ii) });
  const addGroup = () => onChange([...value, { group: DEFAULT_GROUPS[value.length] || "", items: [{ label: "", value: "" }] }]);
  const removeGroup = (gi) => onChange(value.filter((_, j) => j !== gi));

  return (
    <Field label="Full specification sheet" hint="Grouped specs shown on the detail page and in the brochure PDF.">
      <div className="space-y-4">
        {value.map((g, gi) => (
          <div key={gi} className="border border-navy-ink/10 bg-white/40 p-4" data-testid={`yacht-form-specgroup-${gi}`}>
            <div className="mb-3 flex items-center gap-2">
              <input value={g.group} onChange={(e) => setGroup(gi, { group: e.target.value })} placeholder="Group name (e.g. Dimensions)" className={`h-10 flex-1 border px-3 text-sm font-medium ${inputClass}`} data-testid={`yacht-form-specgroup-${gi}-name`} />
              <button type="button" onClick={() => removeGroup(gi)} className="px-2 text-mist hover:text-red-700" aria-label="Remove group" data-testid={`yacht-form-specgroup-${gi}-remove`}><Trash2 size={14} /></button>
            </div>
            <div className="space-y-2 pl-4">
              {g.items.map((it, ii) => (
                <div key={ii} className="flex gap-2">
                  <input value={it.label} onChange={(e) => setItem(gi, ii, "label", e.target.value)} placeholder="Label" className={`h-9 w-2/5 border px-3 text-sm ${inputClass}`} data-testid={`yacht-form-specgroup-${gi}-item-${ii}-label`} />
                  <input value={it.value} onChange={(e) => setItem(gi, ii, "value", e.target.value)} placeholder="Value" className={`h-9 flex-1 border px-3 text-sm ${inputClass}`} data-testid={`yacht-form-specgroup-${gi}-item-${ii}-value`} />
                  <button type="button" onClick={() => removeItem(gi, ii)} className="px-2 text-mist hover:text-red-700" aria-label="Remove" data-testid={`yacht-form-specgroup-${gi}-item-${ii}-remove`}><Trash2 size={12} /></button>
                </div>
              ))}
              {g.items.length < 20 && (
                <button type="button" onClick={() => addItem(gi)} className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.25em] text-gold" data-testid={`yacht-form-specgroup-${gi}-add-item`}><Plus size={10} /> Add row</button>
              )}
            </div>
          </div>
        ))}
        {value.length < 10 && (
          <GhostButton type="button" onClick={addGroup} data-testid="yacht-form-add-specgroup" className="inline-flex items-center gap-2"><Plus size={12} /> Add group</GhostButton>
        )}
      </div>
    </Field>
  );
}
